import React, { FC } from "react";
import { useRecordContext } from "react-admin";

export const CategoryNameField: FC<any> = (props: any) => {
  const record = useRecordContext(props);

  return <span>{`${record.name}`}</span>;
};
